import { Outlet } from "react-router-dom";
import { useAppContext } from "../context/app.context";
import BasePageContainer from "../component/base-page-container";
import CustomLoader from "../component/CustomLoader";

const DashboardPage = () => {
  const { showLeftMenu, isLoading } = useAppContext();

  return (

    <>
      {isLoading && <CustomLoader full />}
      <div className="mt-71">
        <BasePageContainer>
          <section
            className={`dashboardwrap ${!showLeftMenu ? "active" : ""} `}
          >
            <div className="row mx-0">
              <div className="col-md-12 px-md-0">
                <div className="px-5">
                  <div className=" py-md-4">
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </BasePageContainer>
      </div>
    </>
  );
};

export default DashboardPage;
